import { RootState } from "../root.reducer";

export const sortSelector = (state: RootState) => state.sort;
